/* @ngInject */
export default function TransitionEndDirective() {
    return {
        restrict: 'A',
        scope: {
            'transitionEnd':'&',
            'transitionPropertyName':'@transitionPropertyName'
        },
        link: function ($scope, $element) {
            $element.on('transitionend webkitTransitionEnd MSTransitionEnd', function(e) {
                const callBack = function () {
                    $scope.$apply(function() {
                        if($scope.transitionEnd()) {
                            $scope.transitionEnd()();
                        }
                    });
                };
                if($scope.transitionPropertyName) {
                    if(e.propertyName == $scope.transitionPropertyName) {
                        callBack();
                    }
                } else {
                    callBack();
                }
            });
        }
    };
}
